import Vue from 'vue'
import VueRouter from 'vue-router'

import store from './store'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
import UserList from '@/views/users/UserList'
import CreateOrEditUser from '@/views/users/CreateOrEditUser'
import KeyStoreList from '@/views/keystores/KeyStoreList'
import CreateKeyStore from '@/views/keystores/CreateKeyStore'
import TsResponderList from '@/views/signers/TsResponderList'
import CreateTsResponderOrUpdate from '@/views/signers/CreateTsResponderOrUpdate'
import TsProxyList from '@/views/signers/TsProxyList'
import CreateTsProxyOrUpdate from '@/views/signers/CreateTsProxyOrUpdate'
import DocSignerList from '@/views/signers/DocSignerList'
import CreateDocSignerOrUpdate from '@/views/signers/CreateDocSignerOrUpdate'
import OcspResponderList from '@/views/signers/OcspResponderList'
import CreateOcspResponderOrUpdate from '@/views/signers/CreateOcspResponderOrUpdate'
import AuditList from '@/views/audit/AuditList'
import TsReportList from '@/views/report/TsReportList'
import System from '@/views/system/System'

import PermissionDenied from '@/views/PermissionDenied'
import NotFound from '@/views/NotFound'

import Role from './Role'
import Feature from './Feature'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList,
      meta: {
        allowedRoles: [Role.SO, Role.ADMIN, Role.AUDITOR],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/users/add',
      name: 'CreateUser',
      component: CreateOrEditUser,
      meta: {
        allowedRoles: [Role.SO],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/users/:userId/edit',
      name: 'EditUser',
      component: CreateOrEditUser,
      meta: {
        allowedRoles: [Role.SO],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/keystores',
      name: 'KeyStoreList',
      component: KeyStoreList,
      meta: {
        allowedRoles: [Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/keystores/add',
      name: 'CreateKeyStore',
      component: CreateKeyStore,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/tsResponders',
      name: 'TsResponderList',
      component: TsResponderList,
      meta: {
        allowedRoles: [Role.ADMIN, Role.AUDITOR],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/tsResponders/add',
      name: 'CreateTsResponder',
      component: CreateTsResponderOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/tsResponders/:tsResponderId/update',
      name: 'UpdateTsResponder',
      component: CreateTsResponderOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/tsProxies',
      name: 'TsProxyList',
      component: TsProxyList,
      meta: {
        allowedRoles: [Role.ADMIN, Role.AUDITOR],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/tsProxies/add',
      name: 'CreateTsProxy',
      component: CreateTsProxyOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/tsProxies/:tsProxyId/update',
      name: 'UpdateTsProxy',
      component: CreateTsProxyOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/docSigners',
      name: 'DocSignerList',
      component: DocSignerList,
      meta: {
        allowedRoles: [Role.ADMIN, Role.AUDITOR],
        allowedFeatures: [Feature.DSS, Feature.MOBILSIGN]
      }
    },
    {
      path: '/docSigners/add',
      name: 'CreateDocSigner',
      component: CreateDocSignerOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.DSS, Feature.MOBILSIGN]
      }
    }, {
      path: '/docSigners/:docSignerId/update',
      name: 'UpdateDocSigner',
      component: CreateDocSignerOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.DSS, Feature.MOBILSIGN]
      }
    },
    {
      path: '/ocspResponders',
      name: 'OcspResponderList',
      component: OcspResponderList,
      meta: {
        allowedRoles: [Role.ADMIN, Role.AUDITOR],
        allowedFeatures: [Feature.OCSP]
      }
    },
    {
      path: '/ocspResponders/add',
      name: 'CreateOcspResponder',
      component: CreateOcspResponderOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.OCSP]
      }
    },
    {
      path: '/ocspResponders/:ocspResponderId/update',
      name: 'UpdateOcspResponder',
      component: CreateOcspResponderOrUpdate,
      meta: {
        allowedRoles: [Role.ADMIN],
        allowedFeatures: [Feature.OCSP]
      }
    },
    {
      path: '/audit',
      name: 'AuditList',
      component: AuditList,
      meta: {
        allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/tsReport',
      name: 'TsReportList',
      component: TsReportList,
      meta: {
        allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
        allowedFeatures: [Feature.TSP]
      }
    },
    {
      path: '/system',
      name: 'System',
      component: System,
      meta: {
        allowedRoles: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
        allowedFeatures: [Feature.TSP, Feature.DSS, Feature.OCSP, Feature.MOBILSIGN]
      }
    },
    {
      path: '/permissionDenied',
      name: 'PermissionDenied',
      component: PermissionDenied
    },
    {
      path: '/notFound',
      name: 'NotFound',
      alias: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = store.state.currentUser
  const { allowedRoles } = to.meta
  const { allowedFeatures } = to.meta
  if (allowedRoles) {
    if (!currentUser) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
      return
    }

    const matchedRoles = currentUser.roles.filter(role => allowedRoles.includes(role))
    const matchedFeatures = currentUser.features.filter(feature => allowedFeatures.includes(feature))
    if (!matchedRoles.length || !matchedFeatures.length) {
      next({ name: 'PermissionDenied' })
      return
    }
  }

  next()
})

export default router
